import { render } from "./quality.vue?vue&type=template&id=88ae22a2"
import script from "./quality.vue?vue&type=script&lang=js"
export * from "./quality.vue?vue&type=script&lang=js"

import "./quality.vue?vue&type=style&index=0&id=88ae22a2&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__